import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeepakSpinnerTestService {


  private spinnerVisibility: { [key: string]: boolean } = {};

  constructor() {}

  show(cardKey: string) {
    this.spinnerVisibility[cardKey] = true;
  }

  hide(cardKey: string) {
    this.spinnerVisibility[cardKey] = false;
  }

  isVisible(cardKey: string): boolean {
    return this.spinnerVisibility[cardKey];
  }
}
